import React from 'react';

import { browserTracingIntegration } from '@sentry/react';
import * as Sentry from '@sentry/react';
import cookie from 'cookie';
import mixpanel from 'mixpanel-browser';
import type { BeforeSendHookPayload } from 'mixpanel-browser';
import ReactDOM from 'react-dom/client';

import App from './App';
import {
    FINALISE_PAGE_PATH,
    getFinaliseAdvisorState,
    getFinaliseTrackingProperties,
} from './shared/helpers/finaliseAnalytics';

declare global {
    interface Window {
        _env_: any;
        Trustpilot: any;
        tr: any;
        environment: any;
        Intercom: any;
        intercomSettings: any;
        Calendly: any;
        kameleoonQueue: any;
        Kameleoon: any;
        hj: any;
        comet: any;
    }
}

window.environment = window._env_.ENV;

const getApplicationCookieId = () => {
    try {
        const cookies = cookie.parse(document.cookie);
        const appInfo = cookies.application
            ? JSON.parse(cookies.application)
            : {};

        return appInfo.applicationId || '';
    } catch {
        return '';
    }
};

const addFinalisePageViewProperties = (
    event: BeforeSendHookPayload,
): BeforeSendHookPayload => {
    const pagePath =
        event.properties.current_url_path || window.location.pathname;

    if (
        event.event !== '$mp_web_page_view' ||
        pagePath !== FINALISE_PAGE_PATH
    ) {
        return event;
    }

    return {
        ...event,
        properties: {
            ...event.properties,
            ...getFinaliseTrackingProperties({
                advisorState: getFinaliseAdvisorState(
                    window._env_.ENABLE_FINALISE_IN_HOURS_CALL,
                ),
                applicationId: getApplicationCookieId(),
            }),
        },
    };
};

Sentry.init({
    dsn: window._env_.SENTRY,
    integrations: [
        browserTracingIntegration({
            tracePropagationTargets: [
                /^https:\/\/.*\.selina(dev|finance)\.co\.uk\//,
            ],
        }),
    ],
    environment: window._env_.ENV,
    tracesSampleRate: 1.0,
});

mixpanel.init(window._env_.MIXPANEL_ID, {
    api_host: 'https://api-eu.mixpanel.com',
    debug: window.environment.toUpperCase() !== 'PRODUCTION',
    track_pageview: 'url-with-path',
    record_sessions_percent:
        window.environment.toUpperCase() === 'PRODUCTION' ? 100 : 0,
    record_mask_all_inputs: false,
    record_mask_text_selector: '',
    hooks: {
        before_send_events: addFinalisePageViewProperties,
    },
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
